import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlLicitacao = '/service/materiais/licitacao/'

class DetalhesLicitacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            numeroTotal: filtro.numeroTotal,
        }

        return this.conex.post(urlLicitacao + 'detalhesLicitacao/', JSON.stringify(data))
    }
}

export default DetalhesLicitacaoService
